import { notNull } from "../utils"
import TimeZone from "./TimeZone"

export const countryCodeEnum = ['NZ', 'AU', 'GB', 'AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AQ', 'AI', 'AG', 'AR', 'AM', 'AW', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BQ', 'BA', 'BW', 'BV', 'BR', 'IO', 'UM', 'VG', 'VI', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'HR', 'CU', 'CW', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'ET', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'CI', 'IR', 'IQ', 'IE', 'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MK', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'NC', 'NI', 'NE', 'NG', 'NU', 'NF', 'KP', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR', 'QA', 'XK', 'RE', 'RO', 'RU', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI', 'SB', 'SO', 'ZA', 'GS', 'KR', 'SS', 'ES', 'LK', 'SD', 'SR', 'SJ', 'SZ', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'US', 'UY', 'UZ', 'VU', 'VE', 'VN', 'WF', 'EH', 'YE', 'ZM', 'ZW'] as const
export type CountryCode = (typeof countryCodeEnum)[number]

export const currencyCodeEnum = ["NZD", "AUD", "GBP", "CAD", "AFN", "EUR", "ALL", "DZD", "USD", "AOA", "XCD", "ARS", "AMD", "AWG", "AZN", "BSD", "BHD", "BDT", "BBD", "BYN", "BZD", "XOF", "BMD", "BTN", "BOB", "BAM", "BWP", "NOK", "BRL", "BND", "BGN", "BIF", "KHR", "XAF", "CVE", "KYD", "CLP", "CNY", "COP", "KMF", "CDF", "CRC", "HRK", "CUC", "ANG", "CZK", "DKK", "DJF", "DOP", "EGP", "ERN", "ETB", "FKP", "FJD", "XPF", "GMD", "GEL", "GHS", "GIP", "GTQ", "GNF", "GYD", "HTG", "HNL", "HKD", "HUF", "ISK", "INR", "IDR", "IRR", "IQD", "ILS", "JMD", "JPY", "JOD", "KZT", "KES", "KWD", "KGS", "LAK", "LBP", "LSL", "LRD", "LYD", "CHF", "MOP", "MKD", "MGA", "MWK", "MYR", "MVR", "MRO", "MUR", "MXN", "MDL", "MNT", "MAD", "MZN", "MMK", "NAD", "NPR", "NIO", "NGN", "KPW", "OMR", "PKR", "PGK", "PYG", "PEN", "PHP", "PLN", "QAR", "RON", "RUB", "RWF", "SHP", "WST", "STD", "SAR", "RSD", "SCR", "SLL", "SGD", "SBD", "SOS", "ZAR", "KRW", "SSP", "LKR", "SDG", "SRD", "SZL", "SEK", "SYP", "TWD", "TJS", "TZS", "THB", "TOP", "TTD", "TND", "TRY", "TMT", "UGX", "UAH", "AED", "UYU", "UZS", "VUV", "VEF", "VND", "YER", "ZMW"] as const
export type CurrencyCode = (typeof currencyCodeEnum)[number]

export const currencySymbolEnum = ["$", "£", "؋", "€", "L", "د.ج", "Kz", "ƒ", ".د.ب", "৳", "Br", "Fr", "Nu.", "Bs.", "P", "kr", "R$", "лв", "៛", "Esc", "¥", "₡", "kn", "Kč", "Nfk", "D", "ლ", "₵", "Q", "G", "Ft", "₹", "Rp", "﷼", "ع.د", "₪", "د.ا", "Sh", "د.ك", "с", "₭", "ل.ل", "ل.د", "ден", "Ar", "MK", "RM", ".ރ", "UM", "₨", "₮", "د.م.", "MT", "Ks", "C$", "₦", "₩", "ر.ع.", "K", "₲", "S/.", "₱", "zł", "ر.ق", "lei", "₽", "T", "Db", "ر.س", "дин.", "Le", "R", "Rs", "ج.س.", "ЅМ", "฿", "T$", "د.ت", "m", "₴", "د.إ", "Vt", "Bs F", "₫", "ZK"] as const
export type CurrencySymbol = (typeof currencySymbolEnum)[number]

type Currency = {
    code: CurrencyCode
    name: string
    symbol?: CurrencySymbol | undefined
}

type Country = {
    code: CountryCode,
    name: string
    defaultCurrency: Currency
}

export function countryNameFromCode(countryCode: CountryCode) {
    return notNull(countryList.find(({ code }) => code === countryCode))
}

const countryList: Country[] = [
   {
       code: "NZ",
       name: "New Zealand",
       defaultCurrency: {
           code: "NZD",
           name: "New Zealand dollar",
           symbol: "$"
       }
   },
   {
       code: "AU",
       name: "Australia",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "GB",
       name: "United Kingdom",
       defaultCurrency: {
           code: "GBP",
           name: "British pound",
           symbol: "£"
       }
   },
   {
        code: "CA",
        name: "Canada",
        defaultCurrency: {
            code: "CAD",
            name: "Canadian dollar",
            symbol: "$"
        }
    },
   {
       code: "AF",
       name: "Afghanistan",
       defaultCurrency: {
           code: "AFN",
           name: "Afghan afghani",
           symbol: "؋"
       }
   },
   {
       code: "AX",
       name: "Åland Islands",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "AL",
       name: "Albania",
       defaultCurrency: {
           code: "ALL",
           name: "Albanian lek",
           symbol: "L"
       }
   },
   {
       code: "DZ",
       name: "Algeria",
       defaultCurrency: {
           code: "DZD",
           name: "Algerian dinar",
           symbol: "د.ج"
       }
   },
   {
       code: "AS",
       name: "American Samoa",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "AD",
       name: "Andorra",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "AO",
       name: "Angola",
       defaultCurrency: {
           code: "AOA",
           name: "Angolan kwanza",
           symbol: "Kz"
       }
   },
   {
       code: "AI",
       name: "Anguilla",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
        code: 'AQ',
        name: 'Antarctica',
        defaultCurrency: {
            code: "USD",
            name: "United States Dollar",
            symbol: "$"
        }
   },
   {
       code: "AG",
       name: "Antigua and Barbuda",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
       code: "AR",
       name: "Argentina",
       defaultCurrency: {
           code: "ARS",
           name: "Argentine peso",
           symbol: "$"
       }
   },
   {
       code: "AM",
       name: "Armenia",
       defaultCurrency: {
           code: "AMD",
           name: "Armenian dram"
       }
   },
   {
       code: "AW",
       name: "Aruba",
       defaultCurrency: {
           code: "AWG",
           name: "Aruban florin",
           symbol: "ƒ"
       }
   },
   {
       code: "AT",
       name: "Austria",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "AZ",
       name: "Azerbaijan",
       defaultCurrency: {
           code: "AZN",
           name: "Azerbaijani manat"
       }
   },
   {
       code: "BS",
       name: "Bahamas",
       defaultCurrency: {
           code: "BSD",
           name: "Bahamian dollar",
           symbol: "$"
       }
   },
   {
       code: "BH",
       name: "Bahrain",
       defaultCurrency: {
           code: "BHD",
           name: "Bahraini dinar",
           symbol: ".د.ب"
       }
   },
   {
       code: "BD",
       name: "Bangladesh",
       defaultCurrency: {
           code: "BDT",
           name: "Bangladeshi taka",
           symbol: "৳"
       }
   },
   {
       code: "BB",
       name: "Barbados",
       defaultCurrency: {
           code: "BBD",
           name: "Barbadian dollar",
           symbol: "$"
       }
   },
   {
       code: "BY",
       name: "Belarus",
       defaultCurrency: {
           code: "BYN",
           name: "New Belarusian ruble",
           symbol: "Br"
       }
   },
   {
       code: "BE",
       name: "Belgium",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "BZ",
       name: "Belize",
       defaultCurrency: {
           code: "BZD",
           name: "Belize dollar",
           symbol: "$"
       }
   },
   {
       code: "BJ",
       name: "Benin",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "BM",
       name: "Bermuda",
       defaultCurrency: {
           code: "BMD",
           name: "Bermudian dollar",
           symbol: "$"
       }
   },
   {
       code: "BT",
       name: "Bhutan",
       defaultCurrency: {
           code: "BTN",
           name: "Bhutanese ngultrum",
           symbol: "Nu."
       }
   },
   {
       code: "BO",
       name: "Bolivia (Plurinational State of)",
       defaultCurrency: {
           code: "BOB",
           name: "Bolivian boliviano",
           symbol: "Bs."
       }
   },
   {
       code: "BQ",
       name: "Bonaire, Sint Eustatius and Saba",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "BA",
       name: "Bosnia and Herzegovina",
       defaultCurrency: {
           code: "BAM",
           name: "Bosnia and Herzegovina convertible mark"
       }
   },
   {
       code: "BW",
       name: "Botswana",
       defaultCurrency: {
           code: "BWP",
           name: "Botswana pula",
           symbol: "P"
       }
   },
   {
       code: "BV",
       name: "Bouvet Island",
       defaultCurrency: {
           code: "NOK",
           name: "Norwegian krone",
           symbol: "kr"
       }
   },
   {
       code: "BR",
       name: "Brazil",
       defaultCurrency: {
           code: "BRL",
           name: "Brazilian real",
           symbol: "R$"
       }
   },
   {
       code: "IO",
       name: "British Indian Ocean Territory",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "UM",
       name: "United States Minor Outlying Islands",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "VG",
       name: "Virgin Islands (British)",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "VI",
       name: "Virgin Islands (U.S.)",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "BN",
       name: "Brunei Darussalam",
       defaultCurrency: {
           code: "BND",
           name: "Brunei dollar",
           symbol: "$"
       }
   },
   {
       code: "BG",
       name: "Bulgaria",
       defaultCurrency: {
           code: "BGN",
           name: "Bulgarian lev",
           symbol: "лв"
       }
   },
   {
       code: "BF",
       name: "Burkina Faso",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "BI",
       name: "Burundi",
       defaultCurrency: {
           code: "BIF",
           name: "Burundian franc",
           symbol: "Fr"
       }
   },
   {
       code: "KH",
       name: "Cambodia",
       defaultCurrency: {
           code: "KHR",
           name: "Cambodian riel",
           symbol: "៛"
       }
   },
   {
       code: "CM",
       name: "Cameroon",
       defaultCurrency: {
           code: "XAF",
           name: "Central African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "CV",
       name: "Cabo Verde",
       defaultCurrency: {
           code: "CVE",
           name: "Cape Verdean escudo",
           symbol: "Esc"
       }
   },
   {
       code: "KY",
       name: "Cayman Islands",
       defaultCurrency: {
           code: "KYD",
           name: "Cayman Islands dollar",
           symbol: "$"
       }
   },
   {
       code: "CF",
       name: "Central African Republic",
       defaultCurrency: {
           code: "XAF",
           name: "Central African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "TD",
       name: "Chad",
       defaultCurrency: {
           code: "XAF",
           name: "Central African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "CL",
       name: "Chile",
       defaultCurrency: {
           code: "CLP",
           name: "Chilean peso",
           symbol: "$"
       }
   },
   {
       code: "CN",
       name: "China",
       defaultCurrency: {
           code: "CNY",
           name: "Chinese yuan",
           symbol: "¥"
       }
   },
   {
       code: "CX",
       name: "Christmas Island",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "CC",
       name: "Cocos (Keeling) Islands",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "CO",
       name: "Colombia",
       defaultCurrency: {
           code: "COP",
           name: "Colombian peso",
           symbol: "$"
       }
   },
   {
       code: "KM",
       name: "Comoros",
       defaultCurrency: {
           code: "KMF",
           name: "Comorian franc",
           symbol: "Fr"
       }
   },
   {
       code: "CG",
       name: "Congo",
       defaultCurrency: {
           code: "XAF",
           name: "Central African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "CD",
       name: "Congo (Democratic Republic of the)",
       defaultCurrency: {
           code: "CDF",
           name: "Congolese franc",
           symbol: "Fr"
       }
   },
   {
       code: "CK",
       name: "Cook Islands",
       defaultCurrency: {
           code: "NZD",
           name: "New Zealand dollar",
           symbol: "$"
       }
   },
   {
       code: "CR",
       name: "Costa Rica",
       defaultCurrency: {
           code: "CRC",
           name: "Costa Rican colón",
           symbol: "₡"
       }
   },
   {
       code: "HR",
       name: "Croatia",
       defaultCurrency: {
           code: "HRK",
           name: "Croatian kuna",
           symbol: "kn"
       }
   },
   {
       code: "CU",
       name: "Cuba",
       defaultCurrency: {
           code: "CUC",
           name: "Cuban convertible peso",
           symbol: "$"
       }
   },
   {
       code: "CW",
       name: "Curaçao",
       defaultCurrency: {
           code: "ANG",
           name: "Netherlands Antillean guilder",
           symbol: "ƒ"
       }
   },
   {
       code: "CY",
       name: "Cyprus",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "CZ",
       name: "Czech Republic",
       defaultCurrency: {
           code: "CZK",
           name: "Czech koruna",
           symbol: "Kč"
       }
   },
   {
       code: "DK",
       name: "Denmark",
       defaultCurrency: {
           code: "DKK",
           name: "Danish krone",
           symbol: "kr"
       }
   },
   {
       code: "DJ",
       name: "Djibouti",
       defaultCurrency: {
           code: "DJF",
           name: "Djiboutian franc",
           symbol: "Fr"
       }
   },
   {
       code: "DM",
       name: "Dominica",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
       code: "DO",
       name: "Dominican Republic",
       defaultCurrency: {
           code: "DOP",
           name: "Dominican peso",
           symbol: "$"
       }
   },
   {
       code: "EC",
       name: "Ecuador",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "EG",
       name: "Egypt",
       defaultCurrency: {
           code: "EGP",
           name: "Egyptian pound",
           symbol: "£"
       }
   },
   {
       code: "SV",
       name: "El Salvador",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "GQ",
       name: "Equatorial Guinea",
       defaultCurrency: {
           code: "XAF",
           name: "Central African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "ER",
       name: "Eritrea",
       defaultCurrency: {
           code: "ERN",
           name: "Eritrean nakfa",
           symbol: "Nfk"
       }
   },
   {
       code: "EE",
       name: "Estonia",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "ET",
       name: "Ethiopia",
       defaultCurrency: {
           code: "ETB",
           name: "Ethiopian birr",
           symbol: "Br"
       }
   },
   {
       code: "FK",
       name: "Falkland Islands (Malvinas)",
       defaultCurrency: {
           code: "FKP",
           name: "Falkland Islands pound",
           symbol: "£"
       }
   },
   {
       code: "FO",
       name: "Faroe Islands",
       defaultCurrency: {
           code: "DKK",
           name: "Danish krone",
           symbol: "kr"
       }
   },
   {
       code: "FJ",
       name: "Fiji",
       defaultCurrency: {
           code: "FJD",
           name: "Fijian dollar",
           symbol: "$"
       }
   },
   {
       code: "FI",
       name: "Finland",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "FR",
       name: "France",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "GF",
       name: "French Guiana",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "PF",
       name: "French Polynesia",
       defaultCurrency: {
           code: "XPF",
           name: "CFP franc",
           symbol: "Fr"
       }
   },
   {
       code: "TF",
       name: "French Southern Territories",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "GA",
       name: "Gabon",
       defaultCurrency: {
           code: "XAF",
           name: "Central African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "GM",
       name: "Gambia",
       defaultCurrency: {
           code: "GMD",
           name: "Gambian dalasi",
           symbol: "D"
       }
   },
   {
       code: "GE",
       name: "Georgia",
       defaultCurrency: {
           code: "GEL",
           name: "Georgian Lari",
           symbol: "ლ"
       }
   },
   {
       code: "DE",
       name: "Germany",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "GH",
       name: "Ghana",
       defaultCurrency: {
           code: "GHS",
           name: "Ghanaian cedi",
           symbol: "₵"
       }
   },
   {
       code: "GI",
       name: "Gibraltar",
       defaultCurrency: {
           code: "GIP",
           name: "Gibraltar pound",
           symbol: "£"
       }
   },
   {
       code: "GR",
       name: "Greece",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "GL",
       name: "Greenland",
       defaultCurrency: {
           code: "DKK",
           name: "Danish krone",
           symbol: "kr"
       }
   },
   {
       code: "GD",
       name: "Grenada",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
       code: "GP",
       name: "Guadeloupe",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "GU",
       name: "Guam",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "GT",
       name: "Guatemala",
       defaultCurrency: {
           code: "GTQ",
           name: "Guatemalan quetzal",
           symbol: "Q"
       }
   },
   {
       code: "GG",
       name: "Guernsey",
       defaultCurrency: {
           code: "GBP",
           name: "British pound",
           symbol: "£"
       }
   },
   {
       code: "GN",
       name: "Guinea",
       defaultCurrency: {
           code: "GNF",
           name: "Guinean franc",
           symbol: "Fr"
       }
   },
   {
       code: "GW",
       name: "Guinea-Bissau",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "GY",
       name: "Guyana",
       defaultCurrency: {
           code: "GYD",
           name: "Guyanese dollar",
           symbol: "$"
       }
   },
   {
       code: "HT",
       name: "Haiti",
       defaultCurrency: {
           code: "HTG",
           name: "Haitian gourde",
           symbol: "G"
       }
   },
   {
       code: "HM",
       name: "Heard Island and McDonald Islands",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "VA",
       name: "Holy See",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "HN",
       name: "Honduras",
       defaultCurrency: {
           code: "HNL",
           name: "Honduran lempira",
           symbol: "L"
       }
   },
   {
       code: "HK",
       name: "Hong Kong",
       defaultCurrency: {
           code: "HKD",
           name: "Hong Kong dollar",
           symbol: "$"
       }
   },
   {
       code: "HU",
       name: "Hungary",
       defaultCurrency: {
           code: "HUF",
           name: "Hungarian forint",
           symbol: "Ft"
       }
   },
   {
       code: "IS",
       name: "Iceland",
       defaultCurrency: {
           code: "ISK",
           name: "Icelandic króna",
           symbol: "kr"
       }
   },
   {
       code: "IN",
       name: "India",
       defaultCurrency: {
           code: "INR",
           name: "Indian rupee",
           symbol: "₹"
       }
   },
   {
       code: "ID",
       name: "Indonesia",
       defaultCurrency: {
           code: "IDR",
           name: "Indonesian rupiah",
           symbol: "Rp"
       }
   },
   {
       code: "CI",
       name: "Côte d'Ivoire",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "IR",
       name: "Iran (Islamic Republic of)",
       defaultCurrency: {
           code: "IRR",
           name: "Iranian rial",
           symbol: "﷼"
       }
   },
   {
       code: "IQ",
       name: "Iraq",
       defaultCurrency: {
           code: "IQD",
           name: "Iraqi dinar",
           symbol: "ع.د"
       }
   },
   {
       code: "IE",
       name: "Ireland",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "IM",
       name: "Isle of Man",
       defaultCurrency: {
           code: "GBP",
           name: "British pound",
           symbol: "£"
       }
   },
   {
       code: "IL",
       name: "Israel",
       defaultCurrency: {
           code: "ILS",
           name: "Israeli new shekel",
           symbol: "₪"
       }
   },
   {
       code: "IT",
       name: "Italy",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "JM",
       name: "Jamaica",
       defaultCurrency: {
           code: "JMD",
           name: "Jamaican dollar",
           symbol: "$"
       }
   },
   {
       code: "JP",
       name: "Japan",
       defaultCurrency: {
           code: "JPY",
           name: "Japanese yen",
           symbol: "¥"
       }
   },
   {
       code: "JE",
       name: "Jersey",
       defaultCurrency: {
           code: "GBP",
           name: "British pound",
           symbol: "£"
       }
   },
   {
       code: "JO",
       name: "Jordan",
       defaultCurrency: {
           code: "JOD",
           name: "Jordanian dinar",
           symbol: "د.ا"
       }
   },
   {
       code: "KZ",
       name: "Kazakhstan",
       defaultCurrency: {
           code: "KZT",
           name: "Kazakhstani tenge"
       }
   },
   {
       code: "KE",
       name: "Kenya",
       defaultCurrency: {
           code: "KES",
           name: "Kenyan shilling",
           symbol: "Sh"
       }
   },
   {
       code: "KI",
       name: "Kiribati",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "KW",
       name: "Kuwait",
       defaultCurrency: {
           code: "KWD",
           name: "Kuwaiti dinar",
           symbol: "د.ك"
       }
   },
   {
       code: "KG",
       name: "Kyrgyzstan",
       defaultCurrency: {
           code: "KGS",
           name: "Kyrgyzstani som",
           symbol: "с"
       }
   },
   {
       code: "LA",
       name: "Lao People's Democratic Republic",
       defaultCurrency: {
           code: "LAK",
           name: "Lao kip",
           symbol: "₭"
       }
   },
   {
       code: "LV",
       name: "Latvia",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "LB",
       name: "Lebanon",
       defaultCurrency: {
           code: "LBP",
           name: "Lebanese pound",
           symbol: "ل.ل"
       }
   },
   {
       code: "LS",
       name: "Lesotho",
       defaultCurrency: {
           code: "LSL",
           name: "Lesotho loti",
           symbol: "L"
       }
   },
   {
       code: "LR",
       name: "Liberia",
       defaultCurrency: {
           code: "LRD",
           name: "Liberian dollar",
           symbol: "$"
       }
   },
   {
       code: "LY",
       name: "Libya",
       defaultCurrency: {
           code: "LYD",
           name: "Libyan dinar",
           symbol: "ل.د"
       }
   },
   {
       code: "LI",
       name: "Liechtenstein",
       defaultCurrency: {
           code: "CHF",
           name: "Swiss franc",
           symbol: "Fr"
       }
   },
   {
       code: "LT",
       name: "Lithuania",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "LU",
       name: "Luxembourg",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "MO",
       name: "Macao",
       defaultCurrency: {
           code: "MOP",
           name: "Macanese pataca",
           symbol: "P"
       }
   },
   {
       code: "MK",
       name: "Macedonia (the former Yugoslav Republic of)",
       defaultCurrency: {
           code: "MKD",
           name: "Macedonian denar",
           symbol: "ден"
       }
   },
   {
       code: "MG",
       name: "Madagascar",
       defaultCurrency: {
           code: "MGA",
           name: "Malagasy ariary",
           symbol: "Ar"
       }
   },
   {
       code: "MW",
       name: "Malawi",
       defaultCurrency: {
           code: "MWK",
           name: "Malawian kwacha",
           symbol: "MK"
       }
   },
   {
       code: "MY",
       name: "Malaysia",
       defaultCurrency: {
           code: "MYR",
           name: "Malaysian ringgit",
           symbol: "RM"
       }
   },
   {
       code: "MV",
       name: "Maldives",
       defaultCurrency: {
           code: "MVR",
           name: "Maldivian rufiyaa",
           symbol: ".ރ"
       }
   },
   {
       code: "ML",
       name: "Mali",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "MT",
       name: "Malta",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "MH",
       name: "Marshall Islands",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "MQ",
       name: "Martinique",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "MR",
       name: "Mauritania",
       defaultCurrency: {
           code: "MRO",
           name: "Mauritanian ouguiya",
           symbol: "UM"
       }
   },
   {
       code: "MU",
       name: "Mauritius",
       defaultCurrency: {
           code: "MUR",
           name: "Mauritian rupee",
           symbol: "₨"
       }
   },
   {
       code: "YT",
       name: "Mayotte",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "MX",
       name: "Mexico",
       defaultCurrency: {
           code: "MXN",
           name: "Mexican peso",
           symbol: "$"
       }
   },
   {
       code: "FM",
       name: "Micronesia (Federated States of)",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "MD",
       name: "Moldova (Republic of)",
       defaultCurrency: {
           code: "MDL",
           name: "Moldovan leu",
           symbol: "L"
       }
   },
   {
       code: "MC",
       name: "Monaco",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "MN",
       name: "Mongolia",
       defaultCurrency: {
           code: "MNT",
           name: "Mongolian tögrög",
           symbol: "₮"
       }
   },
   {
       code: "ME",
       name: "Montenegro",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "MS",
       name: "Montserrat",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
       code: "MA",
       name: "Morocco",
       defaultCurrency: {
           code: "MAD",
           name: "Moroccan dirham",
           symbol: "د.م."
       }
   },
   {
       code: "MZ",
       name: "Mozambique",
       defaultCurrency: {
           code: "MZN",
           name: "Mozambican metical",
           symbol: "MT"
       }
   },
   {
       code: "MM",
       name: "Myanmar",
       defaultCurrency: {
           code: "MMK",
           name: "Burmese kyat",
           symbol: "Ks"
       }
   },
   {
       code: "NA",
       name: "Namibia",
       defaultCurrency: {
           code: "NAD",
           name: "Namibian dollar",
           symbol: "$"
       }
   },
   {
       code: "NR",
       name: "Nauru",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "NP",
       name: "Nepal",
       defaultCurrency: {
           code: "NPR",
           name: "Nepalese rupee",
           symbol: "₨"
       }
   },
   {
       code: "NL",
       name: "Netherlands",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "NC",
       name: "New Caledonia",
       defaultCurrency: {
           code: "XPF",
           name: "CFP franc",
           symbol: "Fr"
       }
   },
   {
       code: "NI",
       name: "Nicaragua",
       defaultCurrency: {
           code: "NIO",
           name: "Nicaraguan córdoba",
           symbol: "C$"
       }
   },
   {
       code: "NE",
       name: "Niger",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "NG",
       name: "Nigeria",
       defaultCurrency: {
           code: "NGN",
           name: "Nigerian naira",
           symbol: "₦"
       }
   },
   {
       code: "NU",
       name: "Niue",
       defaultCurrency: {
           code: "NZD",
           name: "New Zealand dollar",
           symbol: "$"
       }
   },
   {
       code: "NF",
       name: "Norfolk Island",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "KP",
       name: "Korea (Democratic People's Republic of)",
       defaultCurrency: {
           code: "KPW",
           name: "North Korean won",
           symbol: "₩"
       }
   },
   {
       code: "MP",
       name: "Northern Mariana Islands",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "NO",
       name: "Norway",
       defaultCurrency: {
           code: "NOK",
           name: "Norwegian krone",
           symbol: "kr"
       }
   },
   {
       code: "OM",
       name: "Oman",
       defaultCurrency: {
           code: "OMR",
           name: "Omani rial",
           symbol: "ر.ع."
       }
   },
   {
       code: "PK",
       name: "Pakistan",
       defaultCurrency: {
           code: "PKR",
           name: "Pakistani rupee",
           symbol: "₨"
       }
   },
   {
       code: "PW",
       name: "Palau",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "PS",
       name: "Palestine, State of",
       defaultCurrency: {
           code: "ILS",
           name: "Israeli new sheqel",
           symbol: "₪"
       }
   },
   {
       code: "PA",
       name: "Panama",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "PG",
       name: "Papua New Guinea",
       defaultCurrency: {
           code: "PGK",
           name: "Papua New Guinean kina",
           symbol: "K"
       }
   },
   {
       code: "PY",
       name: "Paraguay",
       defaultCurrency: {
           code: "PYG",
           name: "Paraguayan guaraní",
           symbol: "₲"
       }
   },
   {
       code: "PE",
       name: "Peru",
       defaultCurrency: {
           code: "PEN",
           name: "Peruvian sol",
           symbol: "S/."
       }
   },
   {
       code: "PH",
       name: "Philippines",
       defaultCurrency: {
           code: "PHP",
           name: "Philippine peso",
           symbol: "₱"
       }
   },
   {
       code: "PN",
       name: "Pitcairn",
       defaultCurrency: {
           code: "NZD",
           name: "New Zealand dollar",
           symbol: "$"
       }
   },
   {
       code: "PL",
       name: "Poland",
       defaultCurrency: {
           code: "PLN",
           name: "Polish złoty",
           symbol: "zł"
       }
   },
   {
       code: "PT",
       name: "Portugal",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "PR",
       name: "Puerto Rico",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "QA",
       name: "Qatar",
       defaultCurrency: {
           code: "QAR",
           name: "Qatari riyal",
           symbol: "ر.ق"
       }
   },
   {
       code: "XK",
       name: "Republic of Kosovo",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "RE",
       name: "Réunion",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "RO",
       name: "Romania",
       defaultCurrency: {
           code: "RON",
           name: "Romanian leu",
           symbol: "lei"
       }
   },
   {
       code: "RU",
       name: "Russian Federation",
       defaultCurrency: {
           code: "RUB",
           name: "Russian ruble",
           symbol: "₽"
       }
   },
   {
       code: "RW",
       name: "Rwanda",
       defaultCurrency: {
           code: "RWF",
           name: "Rwandan franc",
           symbol: "Fr"
       }
   },
   {
       code: "BL",
       name: "Saint Barthélemy",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "SH",
       name: "Saint Helena, Ascension and Tristan da Cunha",
       defaultCurrency: {
           code: "SHP",
           name: "Saint Helena pound",
           symbol: "£"
       }
   },
   {
       code: "KN",
       name: "Saint Kitts and Nevis",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
       code: "LC",
       name: "Saint Lucia",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
       code: "MF",
       name: "Saint Martin (French part)",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "PM",
       name: "Saint Pierre and Miquelon",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "VC",
       name: "Saint Vincent and the Grenadines",
       defaultCurrency: {
           code: "XCD",
           name: "East Caribbean dollar",
           symbol: "$"
       }
   },
   {
       code: "WS",
       name: "Samoa",
       defaultCurrency: {
           code: "WST",
           name: "Samoan tālā",
           symbol: "T"
       }
   },
   {
       code: "SM",
       name: "San Marino",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "ST",
       name: "Sao Tome and Principe",
       defaultCurrency: {
           code: "STD",
           name: "São Tomé and Príncipe dobra",
           symbol: "Db"
       }
   },
   {
       code: "SA",
       name: "Saudi Arabia",
       defaultCurrency: {
           code: "SAR",
           name: "Saudi riyal",
           symbol: "ر.س"
       }
   },
   {
       code: "SN",
       name: "Senegal",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "RS",
       name: "Serbia",
       defaultCurrency: {
           code: "RSD",
           name: "Serbian dinar",
           symbol: "дин."
       }
   },
   {
       code: "SC",
       name: "Seychelles",
       defaultCurrency: {
           code: "SCR",
           name: "Seychellois rupee",
           symbol: "₨"
       }
   },
   {
       code: "SL",
       name: "Sierra Leone",
       defaultCurrency: {
           code: "SLL",
           name: "Sierra Leonean leone",
           symbol: "Le"
       }
   },
   {
       code: "SG",
       name: "Singapore",
       defaultCurrency: {
           code: "SGD",
           name: "Singapore dollar",
           symbol: "$"
       }
   },
   {
       code: "SX",
       name: "Sint Maarten (Dutch part)",
       defaultCurrency: {
           code: "ANG",
           name: "Netherlands Antillean guilder",
           symbol: "ƒ"
       }
   },
   {
       code: "SK",
       name: "Slovakia",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "SI",
       name: "Slovenia",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "SB",
       name: "Solomon Islands",
       defaultCurrency: {
           code: "SBD",
           name: "Solomon Islands dollar",
           symbol: "$"
       }
   },
   {
       code: "SO",
       name: "Somalia",
       defaultCurrency: {
           code: "SOS",
           name: "Somali shilling",
           symbol: "Sh"
       }
   },
   {
       code: "ZA",
       name: "South Africa",
       defaultCurrency: {
           code: "ZAR",
           name: "South African rand",
           symbol: "R"
       }
   },
   {
       code: "GS",
       name: "South Georgia and the South Sandwich Islands",
       defaultCurrency: {
           code: "GBP",
           name: "British pound",
           symbol: "£"
       }
   },
   {
       code: "KR",
       name: "Korea (Republic of)",
       defaultCurrency: {
           code: "KRW",
           name: "South Korean won",
           symbol: "₩"
       }
   },
   {
       code: "SS",
       name: "South Sudan",
       defaultCurrency: {
           code: "SSP",
           name: "South Sudanese pound",
           symbol: "£"
       }
   },
   {
       code: "ES",
       name: "Spain",
       defaultCurrency: {
           code: "EUR",
           name: "Euro",
           symbol: "€"
       }
   },
   {
       code: "LK",
       name: "Sri Lanka",
       defaultCurrency: {
           code: "LKR",
           name: "Sri Lankan rupee",
           symbol: "Rs"
       }
   },
   {
       code: "SD",
       name: "Sudan",
       defaultCurrency: {
           code: "SDG",
           name: "Sudanese pound",
           symbol: "ج.س."
       }
   },
   {
       code: "SR",
       name: "Suriname",
       defaultCurrency: {
           code: "SRD",
           name: "Surinamese dollar",
           symbol: "$"
       }
   },
   {
       code: "SJ",
       name: "Svalbard and Jan Mayen",
       defaultCurrency: {
           code: "NOK",
           name: "Norwegian krone",
           symbol: "kr"
       }
   },
   {
       code: "SZ",
       name: "Swaziland",
       defaultCurrency: {
           code: "SZL",
           name: "Swazi lilangeni",
           symbol: "L"
       }
   },
   {
       code: "SE",
       name: "Sweden",
       defaultCurrency: {
           code: "SEK",
           name: "Swedish krona",
           symbol: "kr"
       }
   },
   {
       code: "CH",
       name: "Switzerland",
       defaultCurrency: {
           code: "CHF",
           name: "Swiss franc",
           symbol: "Fr"
       }
   },
   {
       code: "SY",
       name: "Syrian Arab Republic",
       defaultCurrency: {
           code: "SYP",
           name: "Syrian pound",
           symbol: "£"
       }
   },
   {
       code: "TW",
       name: "Taiwan",
       defaultCurrency: {
           code: "TWD",
           name: "New Taiwan dollar",
           symbol: "$"
       }
   },
   {
       code: "TJ",
       name: "Tajikistan",
       defaultCurrency: {
           code: "TJS",
           name: "Tajikistani somoni",
           symbol: "ЅМ"
       }
   },
   {
       code: "TZ",
       name: "Tanzania, United Republic of",
       defaultCurrency: {
           code: "TZS",
           name: "Tanzanian shilling",
           symbol: "Sh"
       }
   },
   {
       code: "TH",
       name: "Thailand",
       defaultCurrency: {
           code: "THB",
           name: "Thai baht",
           symbol: "฿"
       }
   },
   {
       code: "TL",
       name: "Timor-Leste",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "TG",
       name: "Togo",
       defaultCurrency: {
           code: "XOF",
           name: "West African CFA franc",
           symbol: "Fr"
       }
   },
   {
       code: "TK",
       name: "Tokelau",
       defaultCurrency: {
           code: "NZD",
           name: "New Zealand dollar",
           symbol: "$"
       }
   },
   {
       code: "TO",
       name: "Tonga",
       defaultCurrency: {
           code: "TOP",
           name: "Tongan paʻanga",
           symbol: "T$"
       }
   },
   {
       code: "TT",
       name: "Trinidad and Tobago",
       defaultCurrency: {
           code: "TTD",
           name: "Trinidad and Tobago dollar",
           symbol: "$"
       }
   },
   {
       code: "TN",
       name: "Tunisia",
       defaultCurrency: {
           code: "TND",
           name: "Tunisian dinar",
           symbol: "د.ت"
       }
   },
   {
       code: "TR",
       name: "Turkey",
       defaultCurrency: {
           code: "TRY",
           name: "Turkish lira"
       }
   },
   {
       code: "TM",
       name: "Turkmenistan",
       defaultCurrency: {
           code: "TMT",
           name: "Turkmenistan manat",
           symbol: "m"
       }
   },
   {
       code: "TC",
       name: "Turks and Caicos Islands",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "TV",
       name: "Tuvalu",
       defaultCurrency: {
           code: "AUD",
           name: "Australian dollar",
           symbol: "$"
       }
   },
   {
       code: "UG",
       name: "Uganda",
       defaultCurrency: {
           code: "UGX",
           name: "Ugandan shilling",
           symbol: "Sh"
       }
   },
   {
       code: "UA",
       name: "Ukraine",
       defaultCurrency: {
           code: "UAH",
           name: "Ukrainian hryvnia",
           symbol: "₴"
       }
   },
   {
       code: "AE",
       name: "United Arab Emirates",
       defaultCurrency: {
           code: "AED",
           name: "United Arab Emirates dirham",
           symbol: "د.إ"
       }
   },
   {
       code: "US",
       name: "United States of America",
       defaultCurrency: {
           code: "USD",
           name: "United States Dollar",
           symbol: "$"
       }
   },
   {
       code: "UY",
       name: "Uruguay",
       defaultCurrency: {
           code: "UYU",
           name: "Uruguayan peso",
           symbol: "$"
       }
   },
   {
       code: "UZ",
       name: "Uzbekistan",
       defaultCurrency: {
           code: "UZS",
           name: "Uzbekistani so'm"
       }
   },
   {
       code: "VU",
       name: "Vanuatu",
       defaultCurrency: {
           code: "VUV",
           name: "Vanuatu vatu",
           symbol: "Vt"
       }
   },
   {
       code: "VE",
       name: "Venezuela (Bolivarian Republic of)",
       defaultCurrency: {
           code: "VEF",
           name: "Venezuelan bolívar",
           symbol: "Bs F"
       }
   },
   {
       code: "VN",
       name: "Viet Nam",
       defaultCurrency: {
           code: "VND",
           name: "Vietnamese đồng",
           symbol: "₫"
       }
   },
   {
       code: "WF",
       name: "Wallis and Futuna",
       defaultCurrency: {
           code: "XPF",
           name: "CFP franc",
           symbol: "Fr"
       }
   },
   {
       code: "EH",
       name: "Western Sahara",
       defaultCurrency: {
           code: "MAD",
           name: "Moroccan dirham",
           symbol: "د.م."
       }
   },
   {
       code: "YE",
       name: "Yemen",
       defaultCurrency: {
           code: "YER",
           name: "Yemeni rial",
           symbol: "﷼"
       }
   },
   {
       code: "ZM",
       name: "Zambia",
       defaultCurrency: {
           code: "ZMW",
           name: "Zambian kwacha",
           symbol: "ZK"
       }
   },
   {
       code: "ZW",
       name: "Zimbabwe",
       defaultCurrency: {
           code: "BWP",
           name: "Botswana pula",
           symbol: "P"
       }
   }
]

export default countryList

export const currencyList = countryList.map(({ defaultCurrency: { code, name, symbol } }) => {
    return {
        code,
        name,
        symbol,
    }
}).reduce(
    (currencies, current) =>
        currencies.map(({ code }) => code).includes(current.code)
            ? currencies
            : [...currencies, current],
    [] as Currency[]
)

/**
 * This function will return the countrycode based on timezone
 * Mapping done through https://timezonedb.com/time-zones @ 20-may-2024
 * @param timeZone Timezone, as given by JS
 * @returns CountryCode | null
 */
export const getCountryCodeBasedOnTimezone = (timeZone: TimeZone): CountryCode | null => {
    switch (timeZone) {
        case 'Asia/Kabul':
            return 'AF'
        case 'Europe/Tirane':
            return 'AL'
        case 'Africa/Algiers':
            return 'DZ'
        case 'Pacific/Pago_Pago':
            return 'AS'
        case 'Europe/Andorra':
            return 'AD'
        case 'Africa/Luanda':
            return 'AO'
        case 'America/Anguilla':
            return 'AI'
        case 'Antarctica/Casey':
        case 'Antarctica/Davis':
        case 'Antarctica/DumontDUrville':
        case 'Antarctica/Mawson':
        case 'Antarctica/McMurdo':
        case 'Antarctica/Palmer':
        case 'Antarctica/Rothera':
        case 'Antarctica/Syowa':
        case 'Antarctica/Troll':
        case 'Antarctica/Vostok':
            return 'AQ'
        case 'America/Antigua':
            return 'AG'
        case 'America/Argentina/Buenos_Aires':
        case 'America/Argentina/Catamarca':
        case 'America/Argentina/Cordoba':
        case 'America/Argentina/Jujuy':
        case 'America/Argentina/La_Rioja':
        case 'America/Argentina/Mendoza':
        case 'America/Argentina/Rio_Gallegos':
        case 'America/Argentina/Salta':
        case 'America/Argentina/San_Juan':
        case 'America/Argentina/San_Luis':
        case 'America/Argentina/Tucuman':
        case 'America/Argentina/Ushuaia':
            return 'AR'
        case 'Asia/Yerevan':
            return 'AM'
        case 'America/Aruba':
            return 'AW'
        case 'Antarctica/Macquarie':
        case 'Australia/Adelaide':
        case 'Australia/Brisbane':
        case 'Australia/Broken_Hill':
        case 'Australia/Darwin':
        case 'Australia/Eucla':
        case 'Australia/Hobart':
        case 'Australia/Lindeman':
        case 'Australia/Lord_Howe':
        case 'Australia/Melbourne':
        case 'Australia/Perth':
        case 'Australia/Sydney':
            return 'AU'
        case 'Europe/Vienna':
            return 'AT'
        case 'Asia/Baku':
            return 'AZ'
        case 'America/Nassau':
            return 'BS'
        case 'Asia/Bahrain':
            return 'BH'
        case 'Asia/Dhaka':
            return 'BD'
        case 'America/Barbados':
            return 'BB'
        case 'Europe/Minsk':
            return 'BY'
        case 'Europe/Brussels':
            return 'BE'
        case 'America/Belize':
            return 'BZ'
        case 'Africa/Porto-Novo':
            return 'BJ'
        case 'Atlantic/Bermuda':
            return 'BM'
        case 'Asia/Thimphu':
            return 'BT'
        case 'America/La_Paz':
            return 'BO'
        case 'America/Kralendijk':
            return 'BQ'
        case 'Europe/Sarajevo':
            return 'BA'
        case 'Africa/Gaborone':
            return 'BW'
        case 'America/Araguaina':
        case 'America/Bahia':
        case 'America/Belem':
        case 'America/Boa_Vista':
        case 'America/Campo_Grande':
        case 'America/Cuiaba':
        case 'America/Eirunepe':
        case 'America/Fortaleza':
        case 'America/Maceio':
        case 'America/Manaus':
        case 'America/Noronha':
        case 'America/Porto_Velho':
        case 'America/Recife':
        case 'America/Rio_Branco':
        case 'America/Santarem':
        case 'America/Sao_Paulo':
            return 'BR'
        case 'Indian/Chagos':
            return 'IO'
        case 'Asia/Brunei':
            return 'BN'
        case 'Europe/Sofia':
            return 'BG'
        case 'Africa/Ouaga':
            return 'BF'
        case 'Africa/Bujumbura':
            return 'BI'
        case 'Asia/Phnom_Penh':
            return 'KH'
        case 'Africa/Douala':
            return 'CM'
        case 'America/Atikokan':
        case 'America/Blanc-Sablon':
        case 'America/Cambridge_Bay':
        case 'America/Creston':
        case 'America/Dawson':
        case 'America/Dawson_Creek':
        case 'America/Edmonton':
        case 'America/Fort_Nelson':
        case 'America/Glace_Bay':
        case 'America/Goose_Bay':
        case 'America/Halifax':
        case 'America/Inuvik':
        case 'America/Iqaluit':
        case 'America/Moncton':
        case 'America/Rankin_Inlet':
        case 'America/Regina':
        case 'America/Resolute':
        case 'America/St_Johns':
        case 'America/Swift_Current':
        case 'America/Toronto':
        case 'America/Vancouver':
        case 'America/Whitehorse':
        case 'America/Winnipeg':
            return 'CA'
        case 'Atlantic/Cape_Verde':
            return 'CV'
        case 'America/Cayman':
            return 'KY'
        case 'Africa/Bangui':
            return 'CF'
        case 'Africa/Ndjamena':
            return 'TD'
        case 'America/Punta_Arenas':
        case 'America/Santiago':
        case 'Pacific/Easter':
            return 'CL'
        case 'Asia/Shanghai':
        case 'Asia/Urumqi':
            return 'CN'
        case 'Indian/Christmas':
            return 'CX'
        case 'Indian/Cocos':
            return 'CC'
        case 'America/Bogota':
            return 'CO'
        case 'Indian/Comoro':
            return 'KM'
        case 'Africa/Brazzaville':
            return 'CG'
        case 'Africa/Kinshasa':
        case 'Africa/Lubumbashi':
            return 'CD'
        case 'Pacific/Rarotonga':
            return 'CK'
        case 'America/Costa_Rica':
            return 'CR'
        case 'Europe/Zagreb':
            return 'HR'
        case 'America/Havana':
            return 'CU'
        case 'America/Curacao':
            return 'CW'
        case 'Asia/Famagusta':
        case 'Asia/Nicosia':
            return 'CY'
        case 'Europe/Prague':
            return 'CZ'
        case 'Africa/Abidjan':
            return 'CI'
        case 'Europe/Copenhagen':
            return 'DK'
        case 'Africa/Djibouti':
            return 'DJ'
        case 'America/Dominica':
            return 'DM'
        case 'America/Santo_Domingo':
            return 'DO'
        case 'America/Guayaquil':
        case 'Pacific/Galapagos':
            return 'EC'
        case 'Africa/Cairo':
            return 'EG'
        case 'America/El_Salvador':
            return 'SV'
        case 'Africa/Malabo':
            return 'GQ'
        case 'Africa/Asmara':
            return 'ER'
        case 'Europe/Tallinn':
            return 'EE'
        case 'Africa/Addis_Ababa':
            return 'ET'
        case 'Atlantic/Stanley':
            return 'FK'
        case 'Atlantic/Faroe':
            return 'FO'
        case 'Pacific/Fiji':
            return 'FJ'
        case 'Europe/Helsinki':
            return 'FI'
        case 'Europe/Paris':
            return 'FR'
        case 'America/Cayenne':
            return 'GF'
        case 'Pacific/Gambier':
        case 'Pacific/Marquesas':
        case 'Pacific/Tahiti':
            return 'PF'
        case 'Indian/Kerguelen':
            return 'TF'
        case 'Africa/Libreville':
            return 'GA'
        case 'Africa/Banjul':
            return 'GM'
        case 'Asia/Tbilisi':
            return 'GE'
        case 'Europe/Berlin':
            return 'DE'
        case 'Africa/Accra':
            return 'GH'
        case 'Europe/Gibraltar':
            return 'GI'
        case 'Europe/Athens':
            return 'GR'
        case 'America/Danmarkshavn':
        case 'America/Nuuk':
        case 'America/Scoresbysund':
        case 'America/Thule':
            return 'GL'
        case 'America/Grenada':
            return 'GD'
        case 'America/Guadeloupe':
            return 'GP'
        case 'Pacific/Guam':
            return 'GU'
        case 'America/Guatemala':
            return 'GT'
        case 'Europe/Guernsey':
            return 'GG'
        case 'Africa/Conakry':
            return 'GN'
        case 'Africa/Bissau':
            return 'GW'
        case 'America/Guyana':
            return 'GY'
        case 'America/Port-au-Prince':
            return 'HT'
        case 'Europe/Vatican':
            return 'VA'
        case 'America/Tegucigalpa':
            return 'HN'
        case 'Asia/Hong_Kong':
            return 'HK'
        case 'Europe/Budapest':
            return 'HU'
        case 'Atlantic/Reykjavik':
            return 'IS'
        case 'Asia/Kolkata':
            return 'IN'
        case 'Asia/Jakarta':
        case 'Asia/Jayapura':
        case 'Asia/Makassar':
        case 'Asia/Pontianak':
            return 'ID'
        case 'Asia/Tehran':
            return 'IR'
        case 'Asia/Baghdad':
            return 'IQ'
        case 'Europe/Dublin':
            return 'IE'
        case 'Europe/Isle_of_Man':
            return 'IM'
        case 'Asia/Jerusalem':
            return 'IL'
        case 'Europe/Rome':
            return 'IT'
        case 'America/Jamaica':
            return 'JM'
        case 'Asia/Tokyo':
            return 'JP'
        case 'Europe/Jersey':
            return 'JE'
        case 'Asia/Amman':
            return 'JO'
        case 'Asia/Almaty':
        case 'Asia/Aqtau':
        case 'Asia/Aqtobe':
        case 'Asia/Atyrau':
        case 'Asia/Oral':
        case 'Asia/Qostanay':
        case 'Asia/Qyzylorda':
            return 'KZ'
        case 'Africa/Nairobi':
            return 'KE'
        case 'Pacific/Kanton':
        case 'Pacific/Kiritimati':
        case 'Pacific/Tarawa':
            return 'KI'
        case 'Asia/Pyongyang':
            return 'KP'
        case 'Asia/Seoul':
            return 'KR'
        case 'Asia/Kuwait':
            return 'KW'
        case 'Asia/Bishkek':
            return 'KG'
        case 'Asia/Vientiane':
            return 'LA'
        case 'Europe/Riga':
            return 'LV'
        case 'Asia/Beirut':
            return 'LB'
        case 'Africa/Maseru':
            return 'LS'
        case 'Africa/Monrovia':
            return 'LR'
        case 'Africa/Tripoli':
            return 'LY'
        case 'Europe/Vaduz':
            return 'LI'
        case 'Europe/Vilnius':
            return 'LT'
        case 'Europe/Luxembourg':
            return 'LU'
        case 'Asia/Macau':
            return 'MO'
        case 'Europe/Skopje':
            return 'MK'
        case 'Indian/Antananarivo':
            return 'MG'
        case 'Africa/Blantyre':
            return 'MW'
        case 'Asia/Kuala_Lumpur':
        case 'Asia/Kuching':
            return 'MY'
        case 'Indian/Maldives':
            return 'MV'
        case 'Africa/Bamako':
            return 'ML'
        case 'Europe/Malta':
            return 'MT'
        case 'Pacific/Kwajalein':
        case 'Pacific/Majuro':
            return 'MH'
        case 'America/Martinique':
            return 'MQ'
        case 'Africa/Nouakchott':
            return 'MR'
        case 'Indian/Mauritius':
            return 'MU'
        case 'Indian/Mayotte':
            return 'YT'
        case 'America/Bahia_Banderas':
        case 'America/Cancun':
        case 'America/Chihuahua':
        case 'America/Ciudad_Juarez':
        case 'America/Hermosillo':
        case 'America/Matamoros':
        case 'America/Mazatlan':
        case 'America/Merida':
        case 'America/Mexico_City':
        case 'America/Monterrey':
        case 'America/Ojinaga':
        case 'America/Tijuana':
            return 'MX'
        case 'Pacific/Chuuk':
        case 'Pacific/Kosrae':
        case 'Pacific/Pohnpei':
            return 'FM'
        case 'Europe/Chisinau':
            return 'MD'
        case 'Europe/Monaco':
            return 'MC'
        case 'Asia/Choibalsan':
        case 'Asia/Hovd':
        case 'Asia/Ulaanbaatar':
            return 'MN'
        case 'Europe/Podgorica':
            return 'ME'
        case 'America/Montserrat':
            return 'MS'
        case 'Africa/Casablanca':
            return 'MA'
        case 'Africa/Maputo':
            return 'MZ'
        case 'Asia/Yangon':
            return 'MM'
        case 'Africa/Windhoek':
            return 'NA'
        case 'Pacific/Nauru':
            return 'NR'
        case 'Asia/Kathmandu':
            return 'NP'
        case 'Europe/Amsterdam':
            return 'NL'
        case 'Pacific/Noumea':
            return 'NC'
        case 'Pacific/Auckland':
        case 'Pacific/Chatham':
            return 'NZ'
        case 'America/Managua':
            return 'NI'
        case 'Africa/Niamey':
            return 'NE'
        case 'Africa/Lagos':
            return 'NG'
        case 'Pacific/Niue':
            return 'NU'
        case 'Pacific/Norfolk':
            return 'NF'
        case 'Pacific/Saipan':
            return 'MP'
        case 'Europe/Oslo':
            return 'NO'
        case 'Asia/Muscat':
            return 'OM'
        case 'Asia/Karachi':
            return 'PK'
        case 'Pacific/Palau':
            return 'PW'
        case 'Asia/Gaza':
        case 'Asia/Hebron':
            return 'PS'
        case 'America/Panama':
            return 'PA'
        case 'Pacific/Bougainville':
        case 'Pacific/Port_Moresby':
            return 'PG'
        case 'America/Asuncion':
            return 'PY'
        case 'America/Lima':
            return 'PE'
        case 'Asia/Manila':
            return 'PH'
        case 'Pacific/Pitcairn':
            return 'PN'
        case 'Europe/Warsaw':
            return 'PL'
        case 'Atlantic/Azores':
        case 'Atlantic/Madeira':
        case 'Europe/Lisbon':
            return 'PT'
        case 'America/Puerto_Rico':
            return 'PR'
        case 'Asia/Qatar':
            return 'QA'
        case 'Europe/Bucharest':
            return 'RO'
        case 'Asia/Anadyr':
        case 'Asia/Barnaul':
        case 'Asia/Chita':
        case 'Asia/Irkutsk':
        case 'Asia/Kamchatka':
        case 'Asia/Khandyga':
        case 'Asia/Krasnoyarsk':
        case 'Asia/Magadan':
        case 'Asia/Novokuznetsk':
        case 'Asia/Novosibirsk':
        case 'Asia/Omsk':
        case 'Asia/Sakhalin':
        case 'Asia/Srednekolymsk':
        case 'Asia/Tomsk':
        case 'Asia/Ust-Nera':
        case 'Asia/Vladivostok':
        case 'Asia/Yakutsk':
        case 'Asia/Yekaterinburg':
        case 'Europe/Astrakhan':
        case 'Europe/Kaliningrad':
        case 'Europe/Kirov':
        case 'Europe/Moscow':
        case 'Europe/Samara':
        case 'Europe/Saratov':
        case 'Europe/Ulyanovsk':
        case 'Europe/Volgograd':
            return 'RU'
        case 'Africa/Kigali':
            return 'RW'
        case 'Indian/Reunion':
            return 'RE'
        case 'America/St_Barthelemy':
            return 'BL'
        case 'Atlantic/St_Helena':
            return 'SH'
        case 'America/St_Kitts':
            return 'KN'
        case 'America/St_Lucia':
            return 'LC'
        case 'America/Marigot':
            return 'MF'
        case 'America/Miquelon':
            return 'PM'
        case 'America/St_Vincent':
            return 'VC'
        case 'Pacific/Apia':
            return 'WS'
        case 'Europe/San_Marino':
            return 'SM'
        case 'Asia/Riyadh':
            return 'SA'
        case 'Africa/Dakar':
            return 'SN'
        case 'Europe/Belgrade':
            return 'RS'
        case 'Indian/Mahe':
            return 'SC'
        case 'Africa/Freetown':
            return 'SL'
        case 'Asia/Singapore':
            return 'SG'
        case 'America/Lower_Princes':
            return 'SX'
        case 'Europe/Bratislava':
            return 'SK'
        case 'Europe/Ljubljana':
            return 'SI'
        case 'Pacific/Guadalcanal':
            return 'SB'
        case 'Africa/Mogadishu':
            return 'SO'
        case 'Africa/Johannesburg':
            return 'ZA'
        case 'Atlantic/South_Georgia':
            return 'GS'
        case 'Africa/Juba':
            return 'SS'
        case 'Africa/Ceuta':
        case 'Atlantic/Canary':
        case 'Europe/Madrid':
            return 'ES'
        case 'Asia/Colombo':
            return 'LK'
        case 'Africa/Khartoum':
            return 'SD'
        case 'America/Paramaribo':
            return 'SR'
        case 'Arctic/Longyearbyen':
            return 'SJ'
        case 'Africa/Mbabane':
            return 'SZ'
        case 'Europe/Stockholm':
            return 'SE'
        case 'Europe/Zurich':
            return 'CH'
        case 'Asia/Damascus':
            return 'SY'
        case 'Asia/Taipei':
            return 'TW'
        case 'Asia/Dushanbe':
            return 'TJ'
        case 'Africa/Dar_es_Salaam':
            return 'TZ'
        case 'Asia/Bangkok':
            return 'TH'
        case 'Asia/Dili':
            return 'TL'
        case 'Africa/Lome':
            return 'TG'
        case 'Pacific/Fakaofo':
            return 'TK'
        case 'Pacific/Tongatapu':
            return 'TO'
        case 'America/Port_of_Spain':
            return 'TT'
        case 'Africa/Tunis':
            return 'TN'
        case 'Europe/Istanbul':
            return 'TR'
        case 'Asia/Ashgabat':
            return 'TM'
        case 'America/Grand_Turk':
            return 'TC'
        case 'Pacific/Funafuti':
            return 'TV'
        case 'Africa/Kampala':
            return 'UG'
        case 'Europe/Kyiv':
            return 'UA'
        case 'Europe/Simferopol':
            return 'UA'
        case 'Asia/Dubai':
            return 'AE'
        case 'Europe/London':
            return 'GB'
        case 'America/Adak':
        case 'America/Anchorage':
        case 'America/Boise':
        case 'America/Chicago':
        case 'America/Denver':
        case 'America/Detroit':
        case 'America/Indiana/Indianapolis':
        case 'America/Indiana/Knox':
        case 'America/Indiana/Marengo':
        case 'America/Indiana/Petersburg':
        case 'America/Indiana/Tell_City':
        case 'America/Indiana/Vevay':
        case 'America/Indiana/Vincennes':
        case 'America/Indiana/Winamac':
        case 'America/Juneau':
        case 'America/Kentucky/Louisville':
        case 'America/Kentucky/Monticello':
        case 'America/Los_Angeles':
        case 'America/Menominee':
        case 'America/Metlakatla':
        case 'America/New_York':
        case 'America/Nome':
        case 'America/North_Dakota/Beulah':
        case 'America/North_Dakota/Center':
        case 'America/North_Dakota/New_Salem':
        case 'America/Phoenix':
        case 'America/Sitka':
        case 'America/Yakutat':
        case 'Pacific/Honolulu':
            return 'US'
        case 'America/Montevideo':
            return 'UY'
        case 'Asia/Samarkand':
        case 'Asia/Tashkent':
            return 'UZ'
        case 'Pacific/Efate':
            return 'VU'
        case 'America/Caracas':
            return 'VE'
        case 'Asia/Ho_Chi_Minh':
        case 'Asia/Saigon':
            return 'VN'
        case 'Pacific/Wallis':
            return 'WF'
        case 'Africa/El_Aaiun':
            return 'EH'
        case 'Africa/Ouagadougou':
            return 'BF'
        case 'Africa/Sao_Tome':
            return 'ST'
        case 'Europe/Mariehamn':
            return 'AX'
    }

    return null
}